import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 其他付款申请单（平台）
      {
        path: 'financialManagement/otherPaymentSlipsList',
        name: 'financialManagement-otherPaymentSlipsList',
        meta: {
          title: '其他付款申请单',
          auth: true,
          cache: true,
          platformType: 'platform'
        },
        component: _import('shop/otherPaymentSlipsForm/otherPaymentSlipsList')
      },
      // 第三方其他付款申请单
      {
        path: 'thirdPartyPlatform/otherPaymentSlipsList',
        name: 'thirdPartyPlatform-otherPaymentSlipsList',
        meta: {
          title: '第三方其他付款申请单',
          auth: true,
          cache: true,
          platformType: 'third_party'
        },
        component: _import('shop/otherPaymentSlipsForm/otherPaymentSlipsList')
      },
      // 新增其他付款申请单（平台）
      {
        path: 'shop/otherPaymentSlipsForm/add',
        name: 'shop-otherPaymentSlipsForm-add',
        meta: {
          title: '新增其他付款申请单',
          auth: true,
          cache: false,
          platformType: 'platform'
        },
        component: _import('shop/otherPaymentSlipsForm/add')
      },
      // 新增第三方其他付款申请单
      {
        path: 'shop/otherPaymentSlipsForm/thirdAdd',
        name: 'shop-otherPaymentSlipsForm-thirdAdd',
        meta: {
          title: '新增第三方其他付款申请单',
          auth: true,
          cache: false,
          platformType: 'third_party'
        },
        component: _import('shop/otherPaymentSlipsForm/add')
      },
      // 其他付款申请单详情
      {
        path: 'shop/otherPaymentSlipsForm/detail',
        name: 'shop-otherPaymentSlipsForm-detail',
        meta: {
          title: '其他付款申请单详情',
          auth: true,
          cache: false
        },
        component: _import('shop/otherPaymentSlipsForm/detail')
      },
      // 其他付款申请单编辑
      {
        path: 'shop/otherPaymentSlipsForm/edit',
        name: 'shop-otherPaymentSlipsForm-edit',
        meta: {
          title: '其他付款申请单编辑',
          auth: true,
          cache: false
        },
        component: _import('shop/otherPaymentSlipsForm/edit')
      },
      // 其他付款申请单打款
      {
        path: 'shop/otherPaymentSlipsForm/transferPayment',
        name: 'shop-otherPaymentSlipsForm-transferPayment',
        meta: {
          title: '其他付款申请单打款',
          auth: true,
          cache: false
        },
        component: _import('shop/otherPaymentSlipsForm/transferPayment')
      },


      // 预付款申请单（平台）
      {
        path: 'financialManagement/advancePaymentList',
        name: 'financialManagement-advancePaymentList',
        meta: {
          title: '预付款申请单',
          auth: true,
          cache: true,
          platformType: 'platform'
        },
        component: _import('shop/advancePaymentApplicationForm/advancePaymentList')
      },
      // 第三方预付款申请单
      {
        path: 'thirdPartyPlatform/advancePaymentList',
        name: 'thirdPartyPlatform-advancePaymentList',
        meta: {
          title: '第三方预付款申请单',
          auth: true,
          cache: true,
          platformType: 'third_party'
        },
        component: _import('shop/advancePaymentApplicationForm/advancePaymentList')
      },
      // 新增预付款申请单（平台）
      {
        path: 'shop/advancePaymentApplicationForm/add',
        name: 'shop-advancePaymentApplicationForm-add',
        meta: {
          title: '新增预付款申请单',
          auth: true,
          cache: false,
          platformType: 'platform'
        },
        component: _import('shop/advancePaymentApplicationForm/add')
      },
      // 新增第三方预付款申请单
      {
        path: 'shop/advancePaymentApplicationForm/thirdAdd',
        name: 'shop-advancePaymentApplicationForm-thirdAdd',
        meta: {
          title: '新增第三方预付款申请单',
          auth: true,
          cache: false,
          platformType: 'third_party'
        },
        component: _import('shop/advancePaymentApplicationForm/add')
      },
      // 预付款申请单详情
      {
        path: 'shop/advancePaymentApplicationForm/detail',
        name: 'shop-advancePaymentApplicationForm-detail',
        meta: {
          title: '预付款申请单详情',
          auth: true,
          cache: false
        },
        component: _import('shop/advancePaymentApplicationForm/detail')
      },
      // 预付款申请单编辑
      {
        path: 'shop/advancePaymentApplicationForm/edit',
        name: 'shop-advancePaymentApplicationForm-edit',
        meta: {
          title: '预付款申请单编辑',
          auth: true,
          cache: false
        },
        component: _import('shop/advancePaymentApplicationForm/edit')
      },
      // 预付款申请单打款
      {
        path: 'shop/advancePaymentApplicationForm/transferPayment',
        name: 'shop-advancePaymentApplicationForm-transferPayment',
        meta: {
          title: '预付款申请单打款',
          auth: true,
          cache: false
        },
        component: _import('shop/advancePaymentApplicationForm/transferPayment')
      },



      // 付款申请单（平台）
      {
        path: 'financialManagement/list',
        name: 'financialManagement-list',
        meta: {
          title: '付款申请单',
          auth: true,
          cache: true,
          platformType: 'platform'
        },
        component: _import('shop/paymentRequest/list')
      },
      // 第三方付款申请单
      {
        path: 'thirdPartyPlatform/list',
        name: 'thirdPartyPlatform-list',
        meta: {
          title: '第三方付款申请单',
          auth: true,
          cache: true,
          platformType: 'third_party'
        },
        component: _import('shop/paymentRequest/list')
      },
      // 新增付款申请单（平台）
      {
        path: 'shop/paymentRequest/add',
        name: 'shop-paymentRequest-add',
        meta: {
          title: '新增付款申请单',
          auth: true,
          cache: false,
          platformType: 'platform'
        },
        component: _import('shop/paymentRequest/add')
      },
      // 新增第三方付款申请单
      {
        path: 'shop/paymentRequest/thirdAdd',
        name: 'shop-paymentRequest-thirdAdd',
        meta: {
          title: '新增第三方付款申请单',
          auth: true,
          cache: false,
          platformType: 'third_party'
        },
        component: _import('shop/paymentRequest/add')
      },
      // 付款申请单详情
      {
        path: 'shop/paymentRequest/detail',
        name: 'shop-paymentRequest-detail',
        meta: {
          title: '付款申请单详情',
          auth: true,
          cache: false
        },
        component: _import('shop/paymentRequest/detail')
      },
      // 付款申请单编辑
      {
        path: 'shop/paymentRequest/edit',
        name: 'shop-paymentRequest-edit',
        meta: {
          title: '付款申请单编辑',
          auth: true,
          cache: false
        },
        component: _import('shop/paymentRequest/edit')
      },
      // 付款申请单打款
      {
        path: 'shop/paymentRequest/transferPayment',
        name: 'shop-paymentRequest-transferPayment',
        meta: {
          title: '打款',
          auth: true,
          cache: false
        },
        component: _import('shop/paymentRequest/transferPayment')
      },
      // 速优拼
      {
        path: 'syp/hotSearch',
        name: 'syp-hotSearch',
        meta: {
          title: '热门推荐',
          auth: true,
          cache: true
        },
        component: _import('syp/hotSearch/index')
      },
      {
        path: 'syp/sypBasicSet',
        name: 'syp-sypBasicSet',
        meta: {
          title: '基本设置',
          auth: true,
          cache: true
        },
        component: _import('syp/setting/sypBasicSet')
      },
      // 注册审核
      {
        path: 'syp/registrationAudit',
        name: 'syp-registrationAudit',
        meta: {
          title: '注册审核',
          auth: true,
          cache: true
        },
        component: _import('syp/registrationAudit/registrationAudit')
      },
      {
        path: 'syp/balanceManagement/balanceApply',
        name: 'syp-balanceManagement-balanceApply',
        meta: {
          title: '余额申请充值',
          auth: true,
          cache: true
        },
        component: _import('syp/balanceManagement/balanceApply')
      },
      {
        path: 'syp/balanceManagement/balanceRecord',
        name: 'syp-balanceManagement-balanceRecord',
        meta: {
          title: '余额消费记录',
          auth: true,
          cache: true
        },
        component: _import('syp/balanceManagement/balanceRecord')
      },

      // 速优拼用户列表
      {
        path: 'syp/userListSyp/userListSyp',
        name: 'syp-userListSyp-userListSyp',
        meta: {
          title: '速优拼用户列表',
          auth: true,
          cache: true
        },
        component: _import('syp/userListSyp/userListSyp')
      },
      // 速优拼用户详情
      {
        path: 'syp/userListSyp/userDetail',
        name: 'syp-userListSyp-userDetail',
        meta: {
          title: '速优拼用户详情',
          auth: true,
          cache: true
        },
        component: _import('syp/userListSyp/userDetail')
      },
      // 速优拼订单列表
      {
        path: 'syp/orderManagement/orderList',
        name: 'syp-orderManagement-orderList',
        meta: {
          title: '速优拼订单列表',
          auth: true,
          cache: true
        },
        component: _import('syp/orderManagement/orderList')
      },
      // 速优拼订单 详情
      {
        path: 'syp/orderManagement/orderDetail',
        name: 'syp-orderManagement-orderDetail',
        meta: {
          title: '速优拼订单详情',
          auth: true,
          cache: true
        },
        component: _import('syp/orderManagement/orderDetail')
      },

      // 电话销售-呼叫统计
      {
        path: 'telSalesManagement/callStatistics',
        name: 'telSalesManagement-callStatistics',
        meta: {
          title: '呼叫统计',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/callStatistics')
      },
      // 电话销售-呼叫详情
      {
        path: 'telSalesManagement/callDetails',
        name: 'telSalesManagement-callDetails',
        meta: {
          title: '呼叫详情',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/callDetails')
      },
      // 电话销售-批量业绩设置
       {
        path: 'telSalesManagement/batchperformancesetting',
        name: 'telSalesManagement-batchperformancesetting',
        meta: {
          title: '批量业绩设置',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/batchperformancesetting')
      },
      // 电话销售-销售业绩统计
      {
        path: 'telSalesManagement/salesPerformanceStatistics',
        name: 'telSalesManagement-salesPerformanceStatistics',
        meta: {
          title: '销售业绩统计',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/salesPerformanceStatistics')
      },
      // 电话销售-业绩统计
      {
        path: 'telSalesManagement/performanceStatistics',
        name: 'telSalesManagement-performanceStatistics',
        meta: {
          title: '业绩统计',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/performanceStatistics')
      },
      // 电话销售-客服聊天
      {
        path: 'telSalesManagement/customerServiceChat',
        name: 'telSalesManagement-customerServiceChat',
        meta: {
          title: '客服聊天',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/customerServiceChat')
      },
      // 电话销售-售后商品统计
      {
        path: 'telSalesManagement/afterSaleGoodsStatistics',
        name: 'telSalesManagement-afterSaleGoodsStatistics',
        meta: {
          title: '售后商品统计',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/afterSaleGoodsStatistics')
      },
      // 财务管理-商户应付详情表
      {
        path: 'financialManagement/IncomingInitialData',
        name: 'financialManagement-IncomingInitialData',
        meta: {
          title: '商户应付详情表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/IncomingInitialData')
      },
      // 财务管理-数据初始化
      {
        path: 'financialManagement/beginningPeriodCreateAccounts',
        name: 'financialManagement-beginningPeriodCreateAccounts',
        meta: {
          title: '数据初始化',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/beginningPeriodCreateAccounts')
      },
      // 财务管理-期初数据
      {
        path: 'financialManagement/beginningPeriodData',
        name: 'financialManagement-beginningPeriodData',
        meta: {
          title: '期初数据',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/beginningPeriodData')
      },
      // 财务管理-商户提现单
      {
        path: 'financialManagement/paymentOrder',
        name: 'financialManagement-paymentOrder',
        meta: {
          title: '商户提现单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/paymentOrder')
      },
      // 财务管理-商户提现单(新)
      {
        path: 'financialManagement/paymentOrderNew',
        name: 'financialManagement-paymentOrderNew',
        meta: {
          title: '商户提现单(新)',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/paymentOrderNew')
      },
      // 第三方平台-第三方付款单
      {
        path: 'thirdPartyPlatform/douyinPaymentSlip',
        name: 'thirdPartyPlatform-douyinPaymentSlip',
        meta: {
          title: '第三方付款单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/douyinPaymentSlip')
      },
      // 第三方平台-第三方月度账单
      {
        path: 'thirdPartyPlatform/douyinMonthlyStatement',
        name: 'thirdPartyPlatform-douyinMonthlyStatement',
        meta: {
          title: '第三方月度账单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/douyinMonthlyStatement')
      },
      // 第三方平台-第三方抹零单
      {
        path: 'thirdPartyPlatform/douyinMaLingOrder',
        name: 'thirdPartyPlatform-douyinMaLingOrder',
        meta: {
          title: '第三方抹零单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/douyinMaLingOrder')
      },
      // 财务管理-账户信息
      {
        path: 'financialManagement/accountInformation',
        name: 'financialManagement-accountInformation',
        meta: {
          title: '账户信息',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/accountInformation')
      },
      // 财务管理-预付款单
      {
        path: 'financialManagement/advanceSingle',
        name: 'financialManagement-advanceSingle',
        meta: {
          title: '预付款单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/advanceSingle')
      },
      // 财务管理-预付款单(新)
      {
        path: 'financialManagement/advanceSingleNew',
        name: 'financialManagement-advanceSingleNew',
        meta: {
          title: '预付款单(新)',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/advanceSingleNew')
      },
      // 财务管理-抹零单
      {
        path: 'financialManagement/maLingOrder',
        name: 'financialManagement-maLingOrder',
        meta: {
          title: '抹零单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/maLingOrder')
      },
      // 财务管理-商户往来统计表
      {
        path: 'financialManagement/businessTransactionStatistics',
        name: 'financialManagement-businessTransactionStatistics',
        meta: {
          title: '商户往来统计表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/businessTransactionStatistics')
      },
      // 财务管理-月度应付统计表
      {
        path: 'financialManagement/monthlyPayableStatistics',
        name: 'financialManagement-monthlyPayableStatistics',
        meta: {
          title: '月度应付统计表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/monthlyPayableStatistics')
      },
      // 财务管理-飞驴商户月度账单
      {
        path: 'financialManagement/merchantMonthlyStatement',
        name: 'financialManagement-merchantMonthlyStatement',
        meta: {
          title: '飞驴商户月度账单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/merchantMonthlyStatement')
      },
      // 财务管理-质保金统计表
      {
        path: 'financialManagement/statisticalTableOfWarranty',
        name: 'financialManagement-statisticalTableOfWarranty',
        meta: {
          title: '质保金统计表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/statisticalTableOfWarranty')
      },
      // 财务管理-年度报表
      {
        path: 'financialManagement/annualStatement',
        name: 'financialManagement-annualStatement',
        meta: {
          title: '年度报表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/annualStatement')
      },
       // 财务管理-对账单
      {
        path: 'financialManagement/statement',
        name: 'financialManagement-statement',
        meta: {
          title: '对账单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/statement')
      },
      // 财务管理-类目
       {
        path: 'financialManagement/category',
        name: 'financialManagement-category',
        meta: {
          title: '类目',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/category')
      },
      // 财务管理-平台提现单
      {
        path: 'financialManagement/platformWithdrawalRequest',
        name: 'financialManagement-platformWithdrawalRequest',
        meta: {
          title: '平台提现单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/platformWithdrawalRequest')
      },
      // 财务管理-期初建账
      {
        path: 'financialManagement/beginningSetUpAccountingRecords',
        name: 'financialManagement-beginningSetUpAccountingRecords',
        meta: {
          title: '期初建账列表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/beginningSetUpAccountingRecords')
      },
      // 财务管理-其他付款单
      {
        path: 'financialManagement/otherPaymentSlips',
        name: 'financialManagement-otherPaymentSlips',
        meta: {
          title: '其他付款单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/otherPaymentSlips')
      },
      // 财务管理-其他收款单
      {
        path: 'financialManagement/otherReceipts',
        name: 'financialManagement-otherReceipts',
        meta: {
          title: '其他收款单',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/otherReceipts')
      },
      // 财务管理-日记账汇总表
      {
        path: 'financialManagement/journalLedgerSummaryTable',
        name: 'financialManagement-journalLedgerSummaryTable',
        meta: {
          title: '日记账汇总表',
          auth: true,
          cache: true
        },
        component: _import('shop/financialManagement/journalLedgerSummaryTable')
      },


      // 商品推广
      {
        path: 'promotion/productsPromotion',
        name: 'promotion-productsPromotion',
        meta: {
          title: '商品推广',
          auth: true,
          cache: true
        },
        component: _import('shop/promotion/productsPromotion')
      },
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          auth: true
        },
        component: _import('system/index')
      },
      // 工作台
      {
        path: 'workbench/workbench',
        name: 'workbench-workbench',
        meta: {
          title: '工作台',
          auth: true,
          cache: true,
        },
        component: _import('shop/workbench/workbench')
      },
      // 工作台-主管跳转用
      {
        path: 'workbench/workbenchzhuguan',
        name: 'workbench-workbenchzhuguan',
        meta: {
          title: '工作台',
          auth: true,
          cache: false,
        },
        component: _import('shop/workbench/workbenchzhuguan')
      },
      // 主管工作台
      {
        path: 'workbench/supervisorWorkbench',
        name: 'workbench-supervisorWorkbench',
        meta: {
          title: '主管工作台',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/supervisorWorkbench')
      },
      // 共享仓备忘录
      {
        path: 'workbench/warehouseMemo',
        name: 'workbench-warehouseMemo',
        meta: {
          title: '共享仓备忘录',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/warehouseMemo')
      },
      // 今日电话量
      {
        path: 'workbench/todayCallsNum',
        name: 'workbench-todayCallsNum',
        meta: {
          title: '今日电话量',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/todayCallsNum')
      },
      // 搜索条数为0用户
      {
        path: 'workbench/searchUserNumIsZero',
        name: 'workbench-searchUserNumIsZero',
        meta: {
          title: '搜索条数为0用户',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/searchUserNumIsZero')
      },
      // 标记无效用户
      {
        path: 'workbench/invalidUser',
        name: 'workbench-invalidUser',
        meta: {
          title: '标记无效用户',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/invalidUser')
      },
      {
        path: 'workbench/invalidUser/detail',
        name: 'workbench-invalidUser-detail',
        meta: { title: '点击人员-商品详情', auth: true, cache: false },
        component: _import('shop/workbench/invalidUserDetail')
      },
      // 累计达标提醒退款
      {
        path: 'workbench/cumulativeStandardReminderRefund',
        name: 'workbench-cumulativeStandardReminderRefund',
        meta: {
          title: '累计达标提醒退款',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/cumulativeStandardReminderRefund')
      },
      // 累计即将到期
      {
        path: 'workbench/accumulativeTermAboutToExpire',
        name: 'workbench-accumulativeTermAboutToExpire',
        meta: {
          title: '累计即将到期',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/accumulativeTermAboutToExpire')
      },
      // 新用户回访
      {
        path: 'workbench/returnVisitsForNewUsers',
        name: 'workbench-returnVisitsForNewUsers',
        meta: {
          title: '新用户回访',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/returnVisitsForNewUsers')
      },
      // 退货款项核实
      {
        path: 'workbench/verificationOfReturns',
        name: 'workbench-verificationOfReturns',
        meta: {
          title: '退货款项核实',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/verificationOfReturns')
      },
      // 礼品单发
      {
        path: 'workbench/giftSingleShot',
        name: 'workbench-giftSingleShot',
        meta: {
          title: '礼品单发',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/giftSingleShot')
      },
      // 待支付订单
      {
        path: 'workbench/orderToBePaid',
        name: 'workbench-orderToBePaid',
        meta: {
          title: '待支付订单',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/orderToBePaid')
      },
      // 备忘录
      {
        path: 'workbench/memo',
        name: 'workbench-memo',
        meta: {
          title: '备忘录',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/memo')
      },
      // 到货提醒
      {
        path: 'workbench/goodsRemind',
        name: 'workbench-goodsRemind',
        meta: {
          title: '到货提醒',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/goodsRemind')
      },
      // 大屏展示
      {
        path: 'workbench/largeScreenDisplay',
        name: 'workbench-largeScreenDisplay',
        meta: {
          title: '大屏展示',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/largeScreenDisplay')
      },
      {
        path: 'workbench/largeScreenSet',
        name: 'workbench-largeScreenSet',
        meta: {
          title: '大屏设置',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/largeScreenSet')
      },
      {
        path: 'workbench/largeScreenErrorPresentation',
        name: 'workbench-largeScreenErrorPresentation',
        meta: {
          title: '大屏问题配置',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/largeScreenErrorPresentation')
      },
      {
        path: 'workbench/scurryForAccessories',
        name: 'workbench-scurryForAccessories',
        meta: {
          title: '急速找配件',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/scurryForAccessories')
      }, {
        path: 'workbench/purchasingWorkbench',
        name: 'workbench-purchasingWorkbench',
        meta: {
          title: '供应链工作台',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/purchasingWorkbench')
      },
      {
        path: 'workbench/beOrderedLists',
        name: 'workbench-beOrderedLists',
        meta: {
          title: '待下单',
          auth: true,
          cache: true
        },
        component: _import('shop/workbench/beOrderedLists')
      },
      {
        path: 'storehouse/shared',
        name: 'storehouse-shared',
        meta: {
          title: '共享仓管理',
          auth: true
        },
        component: _import('shop/mmanage_shared_repository')
      },
      {
        path: 'goods/serviceItems',
        name: 'goods-serviceItems',
        meta: {
          title: '服务项',
          auth: true
        },
        component: _import('shop/service_items')
      },
      {
        path: 'goods/goodsInventory',
        name: 'goods-goodsInventory',
        meta: {
          title: '商品库存（共享仓）',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/goodsInventory')
      },
      {
        path: 'goods/sanBaoComingOfAge',
        name: 'goods-sanBaoComingOfAge',
        meta: {
          title: '三包超时',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/sanBaoComingOfAge')
      },
      {
        path: 'goods/list',
        name: 'goods-list',
        meta: {
          title: '商品列表',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/index')
      },
      {
        path: 'goods/manage',
        name: 'goods-manage',
        meta: {
          title: '商品管理',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/manage')
      },
      {
        path: 'goods/priceManagement',
        name: 'goods-priceManagement',
        meta: {
          title: '售价管理',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/priceManagement')
      },
      {
        path: 'goods/add',
        name: 'goods-add',
        meta: {
          title: '新增商品',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/add')
      },
      {
        path: 'goods/edit',
        name: 'goods-edit',
        meta: {
          title: '编辑商品',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/edit')
      },
      {
        path: 'goods/setRotationChart',
        name: 'goods-setRotationChart',
        meta: {
          title: '设置轮播图'
          // auth: true,
          // cache: true
        },
        component: _import('shop/goods/setRotationChart')
      },
      {
        path: 'goods/setPrice',
        name: 'goods-setPrice',
        meta: {
          title: '设置区域价'
          // auth: true,
          // cache: true
        },
        component: _import('shop/goods/setPrice')
      },
      {
        path: 'goods/costPriceRecord',
        name: 'goods-costPriceRecord',
        meta: {
          title: '成本价记录'
          // auth: true,
          // cache: true
        },
        component: _import('shop/goods/costPriceRecord')
      },
      // 订单 需求单
      {
        path: 'demandManagement/purchase',
        name: 'storehouse-purchase',
        meta: {
          title: '需求单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order')
      },
      // 接货单
      {
        path: 'demandManagement/receivingOrder',
        name: 'storehouse-receivingOrder',
        meta: {
          title: '接货单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/receivingOrder')
      },
      // 需求合并单
      {
        path: 'demandManagement/purchasePlanSheet',
        name: 'storehouse-purchasePlanSheet',
        meta: {
          title: '需求合并单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/purchasePlanSheet')
      },
      // 计划单
      {
        path: 'demandManagement/pannedPurchaseOrder',
        name: 'storehouse-pannedPurchaseOrder',
        meta: {
          title: '计划单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/pannedPurchaseOrder')
      },
       // 我的共享仓信息
       {
        path: 'storehouse/myGxcInfo',
        name: 'storehouse-myGxcInfo',
        meta: {
          title: '我的共享仓信息',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/myGxcInfo')
      },
       // 共享仓修改申请列表
       {
        path: 'storehouse/gxcInfoReviseApplicationList',
        name: 'storehouse-gxcInfoReviseApplicationList',
        meta: {
          title: '共享仓修改申请列表',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/gxcInfoReviseApplicationList')
      },
       // 共享仓提现单
       {
        path: 'storehouse/gxcWithdrawalOrder',
        name: 'storehouse-gxcWithdrawalOrder',
        meta: {
          title: '共享仓提现单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/gxcWithdrawalOrder')
      },
      // 共享仓开票信息
      {
        path: 'storehouse/gxcInvoiceInformation',
        name: 'storehouse-gxcInvoiceInformation',
        meta: {
          title: '共享仓开票信息',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/gxcInvoiceInformation')
      },
       // 需求单商品查询
       {
        path: 'thirdPartyPlatform/pannedPurchaseGoods',
        name: 'thirdPartyPlatform-pannedPurchaseGoods',
        meta: {
          title: '需求单商品查询',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/pannedPurchaseGoods')
      },
      // 共享仓账单列表
      {
        path: 'storehouse/gxcBillReport',
        name: 'storehouse-gxcBillReport',
        meta: {
          title: '共享仓账单列表',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/gxcBillReport')
      },
      // 共享仓每日账单汇总
      {
        path: 'storehouse/dailyGxcBillReport',
        name: 'storehouse-dailyGxcBillReport',
        meta: {
          title: '共享仓每日账单汇总',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/dailyGxcBillReport')
      },
      // 订单 需求单(新)
      {
        path: 'storehouse/purchaseOrderNew',
        name: 'storehouse-purchaseOrderNew',
        meta: {
          title: '需求单（新）',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/purchaseOrderNew')
      },
      {
        path: 'demandManagement/warehouseReceiptList',
        name: 'storehouse-warehouseReceiptList',
        meta: {
          title: '验收单',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/warehouseReceiptList')
      },
      {
        path: 'storehouse/zeroSet',
        name: 'storehouse-zeroSet',
        meta: {
          title: '0号位设置',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/zeroSet')
      },
      {
        path: 'storehouse/shelfInventory',
        name: 'storehouse-shelfInventory',
        meta: {
          title: '货架库存',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/shelfInventory')
      },
      {
        path: 'storehouse/rackLimit',
        name: 'storehouse-rackLimit',
        meta: {
          title: '货架号限制',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/rackLimit')
      },
      {
        path: 'storehouse/warning',
        name: 'storehouse-warning',
        meta: {
          title: '库存预警',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/warning')
      },
      {
        path: 'storehouse/shelfManagement',
        name: 'storehouse-shelfManagement',
        meta: {
          title: '货架管理',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/shelfManagement')
      },
      {
        path: 'storehouse/InventoryAllocation',
        name: 'storehouse-InventoryAllocation',
        meta: {
          title: '库存调拨',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/InventoryAllocation')
      },
      {
        path: 'storehouse/consumablesList',
        name: 'storehouse-consumablesList',
        meta: {
          title: '耗材单',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/consumablesList')
      },
      {
        path: 'storehouse/lossOverflow',
        name: 'storehouse-lossOverflow',
        meta: {
          title: '报损报溢',
          cache: true,
          auth: true
        },
        component: _import('purchase/order/lossOverflow')
      },
      {
        path: 'storehouse/checkDetail',
        name: 'storehouse-checkDetail',
        meta: {
          title: '报损报溢-明细',
          auth: true
        },
        component: _import('purchase/order/checkDetail')
      },
      // 订单 需求单 明细
      {
        path: 'purchase/detailed',
        name: 'purchase-detailed',
        meta: {
          title: '需求单-明细',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/detail')
      },
      // 订单 需求单 明细
      {
        path: 'purchase/detailedPlan',
        name: 'purchase-detailedPlan',
        meta: {
          title: '采购计划单-明细',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/detailPlan')
      },
      // 需求单明细(新)
      {
        path: 'purchase/detailNew',
        name: 'purchase-detailNew',
        meta: {
          title: '需求单-明细(新)',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/detailNew')
      },
      {
        path: 'purchase/addPurchasePlanSheet',
        name: 'purchase-addPurchasePlanSheet',
        meta: {
          title: '采购计划单新增与编辑',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/addPurchasePlanSheet')
      },
      {
        path: 'purchase/newPurchase',
        name: 'purchase-newPurchase',
        meta: {
          title: '需求单新增与编辑',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/newPurchase')
      },
      {
        path: 'purchase/newPurchaseNew',
        name: 'purchase-newPurchaseNew',
        meta: {
          title: '需求单新增与编辑（新）',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/newPurchaseNew')
      },
      {
        path: 'storehouse/returnStorage',
        name: 'storehouse-returnStorage',
        meta: {
          title: '退货库存',
          auth: true,
          cache: true
        },
        component: _import('purchase/order/returnStorage')
      },
      // 订单 订单 列表
      {
        path: 'order/list',
        name: 'order-list',
        meta: {
          title: '订单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/order/list')
      },
      // 塑料件 订单 列表
      {
        path: 'order/plasticPartsOrder',
        name: 'order-plasticPartsOrder',
        meta: {
          title: '塑料件订单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/order/plasticPartsOrder')
      },
      {
        path: 'order/distributionOrderList',
        name: 'order-distributionOrderList',
        meta: {
          title: '操作员订单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/order/distributionOrderList')
      },
      // 订单 累计活动订单
      {
        path: 'order/cumulativeOrder',
        name: 'order-cumulativeOrder',
        meta: {
          title: '累计活动订单',
          auth: true,
          cache: true
        },
        component: _import('shop/order/cumulativeOrder')
      },

      // 剥离订单列表
      {
        path: 'order/speelOrderList',
        name: 'order-speelOrderList',
        meta: {
          title: '剥离订单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/order/speelOrderList')
      },
      // 商户退货列表
      // {
      //   path: 'storehouse/supplierReturnList',
      //   name: 'storehouse-supplierReturnList',
      //   meta: {
      //     title: '商户退货列表',
      //     auth: true,
      //     cache: true
      //   },
      //   component: _import('shop/order/supplierReturnList')
      // },

      // 订单 退货订单列表
      {
        path: 'order/returnList',
        name: 'order-returnList',
        meta: {
          title: '退货订单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/order/returnList')
      },
      // 订单 订单 详情
      {
        path: 'order/detail',
        name: 'order-detail',
        meta: {
          title: '订单详情',
          auth: true
        },
        component: _import('shop/order/detail')
      },
      // 订单 订单 详情(新)
      {
        path: 'order/detailNew',
        name: 'order-detailNew',
        meta: {
          title: '订单详情(新)',
          auth: true
        },
        component: _import('shop/order/detailNew')
      },
      // 塑料件 订单 详情(新)
      {
        path: 'order/plasticPartsDetail',
        name: 'order-plasticPartsDetail',
        meta: {
          title: '订单详情(塑料件)',
          auth: true
        },
        component: _import('shop/order/plasticPartsDetail')
      },
      // 商户列表
      {
        path: 'factory/list',
        name: 'factory-list',
        meta: {
          title: '子商户列表',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/index')
      },
      // 商户标签
      {
        path: 'factory/supplierTags',
        name: 'factory-supplierTags',
        meta: {
          title: '子商户标签',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/supplierTags')
      },
      // 商户信息
      {
        path: 'demandManagement/supplierInfo',
        name: 'factory-supplierInfo',
        meta: {
          title: '采购跟踪',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/supplierInfo')
      },
            // 商户资料
            {
              path: 'factory/merchantProfile',
              name: 'factory-merchantProfile',
              meta: {
                title: '商户资料',
                auth: true,
                cache: true
              },
              component: _import('shop/shopt/merchantProfile')
            },
            // 每日商户资金账单
            {
              path: 'factory/dailyMerchantFundStatement',
              name: 'factory-dailyMerchantFundStatement',
              meta: {
                title: '每日商户资金账单',
                auth: true,
                cache: true
              },
              component: _import('shop/shopt/dailyMerchantFundStatement')
            },
            // 每日商户资金账单（业务明细）
            {
              path: 'factory/dailyMerchantFundDetail',
              name: 'factory-dailyMerchantFundDetail',
              meta: {
                title: '业务明细',
                auth: true,
                cache: true
              },
              component: _import('shop/shopt/dailyMerchantFundDetail')
            },
            // 商户账单进出明细（商户入口）
            {
              path: 'factory/vendorBillDetail',
              name: 'factory-vendorBillDetail',
              meta: {
                title: '交易账单',
                auth: true,
                cache: true
              },
              component: _import('shop/shopt/vendorBillDetail')
            },
      // 商户信息入驻
      {
        path: 'factory/supplierInformation',
        name: 'factory-supplierInformation',
        meta: {
          title: '商户信息入驻',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/supplierInformation')
      },
      // 商品分类
      {
        path: 'goods/classify',
        name: 'goods-classify',
        meta: {
          title: '商品分类',
          auth: true,
          cache: true
        },
        component: _import('shop/commodity/index')
      },
      // 商品广告位
      {
        path: 'goods/advertisingPlace',
        name: 'goods-advertisingPlace',
        meta: {
          title: '商品广告位',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/advertisingPlace')
      },
      // 进出明细
      {
        path: 'goods/particular',
        name: 'goods-particular',
        meta: {
          title: '进出明细',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/particular')
      },
      // 规格管理
      {
        path: 'goods/specification',
        name: 'goods-specification',
        meta: {
          title: '规格管理',
          auth: true,
          cache: true
        },
        component: _import('shop/Specification/index')
      },
      // 商品规格
      {
        path: 'goods/specifications',
        name: 'goods-specifications',
        meta: {
          title: '商品规格',
          auth: true,
          cache: true
        },
        component: _import('shop/Specifications/index')
      },
      // 类型管理
      {
        path: 'goods/managementType',
        name: 'goods-managementType',
        meta: {
          title: '类型管理',
          auth: true,
          cache: true
        },
        component: _import('shop/managementType/index')
      },
      // 用户列表
      {
        path: 'user/list',
        name: 'user-list',
        meta: {
          title: '用户管理',
          auth: true,
          cache: true
        },
        component: _import('shop/userList/index')
      },
      // 用户详情
      {
        path: 'user/detail',
        name: 'user-detail',
        meta: {
          title: '用户详情',
          auth: true,
          cache: false
        },
        component: _import('shop/userList/detail')
      },
      // 用户资料
      {
        path: 'user/information',
        name: 'user-information',
        meta: {
          title: '用户资料',
          auth: true,
          cache: false
        },
        component: _import('shop/userList/userInformation')
      },
      // 用户类别设置
      {
        path: 'user/userCategorySettings',
        name: 'user-userCategorySettings',
        meta: {
          title: '用户类别设置',
          auth: true,
          cache: true
        },
        component: _import('shop/userList/userCategorySettings')
      },
      // 用户标签
      {
        path: 'user/userTags',
        name: 'user-userTags',
        meta: {
          title: '用户类别设置',
          auth: true,
          cache: true
        },
        component: _import('shop/userList/userTags')
      },
      // 累计活动详情
      {
        path: 'user/cumulativeEventDetail',
        name: 'user-cumulativeEventDetail',
        meta: {
          title: '累计活动详情',
          auth: true,
          cache: false
        },
        component: _import('shop/userList/cumulativeEventDetail')
      },
      // 累计活动详情
      {
        path: 'user/placeOrder',
        name: 'user-placeOrder',
        meta: {
          title: '代客下单',
          auth: true,
          cache: false
        },
        component: _import('shop/userList/placeOrder')
      },
      // 帐号管理
      {
        path: 'authority/account',
        name: 'authority-account',
        meta: {
          title: '帐号管理',
          auth: true,
          cache: true
        },
        component: _import('shop/property/account')
      },
      // 角色管理
      {
        path: 'authority/role',
        name: 'authority-role',
        meta: {
          title: '角色管理',
          auth: true,
          cache: true
        },
        component: _import('shop/property/role')
      },
      // 权限节点管理
      {
        path: 'authority/propertyNode',
        name: 'authority-propertyNode',
        meta: {
          title: '权限节点管理',
          auth: true,
          cache: true
        },
        component: _import('shop/property/propertyNode')
      },
      // OA权限管理
      {
        path: 'authority/OAPermissionManagement',
        name: 'authority-OAPermissionManagement',
        meta: {
          title: 'OA权限管理',
          auth: true,
          cache: true
        },
        component: _import('shop/property/OAPermissionManagement')
      },
      // 页面权限管理
      {
        path: 'authority/pagePermissionManagement',
        name: 'authority-pagePermissionManagement',
        meta: {
          title: '页面权限管理',
          auth: true,
          cache: true
        },
        component: _import('shop/property/pagePermissionManagement')
      },
      // 专区管理
      {
        path: 'goods/specialArea',
        name: 'goods-specialArea',
        meta: {
          title: '专区管理',
          auth: true,
          cache: true
        },
        component: _import('shop/specialArea/index')
      },
      // 管理商品
      {
        path: 'specialArea/goodList',
        name: 'specialArea-goodList',
        meta: {
          title: '管理商品',
          auth: true,
          cache: true
        },
        component: _import('shop/specialArea/goodList')
      },
      // 限时折扣
      {
        path: 'promoteSale/promotion',
        name: 'promoteSale-promotion',
        meta: {
          title: '限时折扣管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/promotion')
      },
      // 扫码活动管理
      {
        path: 'promoteSale/scanCodeActivityManagement',
        name: 'promoteSale-scanCodeActivityManagement',
        meta: {
          title: '扫码活动管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/scanCodeActivityManagement')
      },
      // 商品管理
      {
        path: 'promoteSale/goodManage',
        name: 'promoteSale-goodManage',
        meta: {
          title: '商品管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/goodManage')
      },
       // 首件超低价
      {
        path: 'promoteSale/newProductSpecial',
        name: 'promoteSale-newProductSpecial',
        meta: {
          title: '首件超低价',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/newProductSpecial')
      },
       // 积分商品池
       {
        path: 'promoteSale/pointsGoodsPool',
        name: 'promoteSale-pointsGoodsPool',
        meta: {
          title: '积分商品池',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/pointsGoodsPool')
      },
       // 限时秒杀
       {
        path: 'promoteSale/timeLimitSeckill',
        name: 'promoteSale-timeLimitSeckill',
        meta: {
          title: '限时秒杀',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/timeLimitSeckill')
      },
      // 买多真便宜
      {
        path: 'promoteSale/bargainToBuy',
        name: 'promoteSale-bargainToBuy',
        meta: {
          title: '买多真便宜',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/bargainToBuy')
      },
      // 退货金额统计表
      {
        path: 'statistics/returnAmountStatistics',
        name: 'statistics-returnAmountStatistics',
        meta: {
          title: '退货金额统计表 ',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/returnAmountStatistics')
      },
      // 累计活动统计表
      {
        path: 'statistics/cumulativeActivityStatistics',
        name: 'statistics-cumulativeActivityStatistics',
        meta: {
          title: '累计活动统计表',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/cumulativeActivityStatistics')
      },
      // 礼品资金流水统计表
      {
        path: 'statistics/giftFundStatement',
        name: 'statistics-giftFundStatement',
        meta: {
          title: '礼品资金流水 ',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/giftFundStatement')
      },
      // 订单统计
      {
        path: 'statistics/order',
        name: 'statistics-order',
        meta: {
          title: '订单统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/order')
      },
       // 商城订单统计
       {
        path: 'statistics/order1',
        name: 'statistics-order1',
        meta: {
          title: '商城订单统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/order1')
      },
      // 用户信息
      {
        path: 'statistics/userListByGid',
        name: 'statistics-userListByGid',
        meta: {
          title: '用户信息',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/userListByGid')
      },
      // 利润统计
      {
        path: 'statistics/profit',
        name: 'statistics-profit',
        meta: {
          title: '利润统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/profit')
      },
      // 售后统计
      {
        path: 'statistics/afterStatistics',
        name: 'statistics-afterStatistics',
        meta: {
          title: '售后统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/afterStatistics')
      },
      // 订单用户统计
      {
        path: 'statistics/userOrder',
        name: 'statistics-userOrder',
        meta: {
          title: '用户订单',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/userOrder')
      },
      // 用户点击统计
      {
        path: 'statistics/memberClickLog',
        name: 'statistics-memberClickLog',
        meta: {
          title: '用户点击统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/memberClickLog')
      },
      // 商品订单统计
      {
        path: 'statistics/goodOrderStatistic',
        name: 'statistics-goodOrderStatistic',
        meta: {
          title: '商品订单统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/goodOrderStatistic')
      },
      // 客户增长分析
      {
        path: 'statistics/newUser',
        name: 'statistics-newUser',
        meta: {
          title: '客户增长分析',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/newUser')
      },
      // 商品分析
      {
        path: 'statistics/goodAnalysis',
        name: 'statistics-goodAnalysis',
        meta: {
          title: '商品分析',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/goodAnalysis')
      },
      // 操作员业绩
      {
        path: 'statistics/orderAmount',
        name: 'statistics-orderAmount',
        meta: {
          title: '操作员业绩',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/orderAmount')
      },
      // 销售额影响因素分析
      {
        path: 'statistics/salesAnalysis',
        name: 'statistics-salesAnalysis',
        meta: {
          title: '销售额分析',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/salesAnalysis')
      },
      // 功夫钳统计
      {
        path: 'statistics/predepoit_statistic',
        name: 'statistics-predepoit_statistic',
        meta: {
          title: '功夫钳统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/predepoit_statistic')
      },
      // 专享订单
      {
        path: 'statistics/exclusiveOrder',
        name: 'statistics-exclusiveOrder',
        meta: {
          title: '专享订单',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/exclusiveOrder')
      },
      // 浏览记录
      {
        path: 'statistics/browsinghistory',
        name: 'statistics-browsinghistory',
        meta: {
          title: '浏览记录',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/browsinghistory')
      },
      // 用户浏览记录
      {
        path: 'statistics/userbrowsing',
        name: 'statistics-userbrowsing',
        meta: {
          title: '用户浏览记录', auth: true, cache: true
        },
        component: _import('shop/statistics/userbrowsing')
      },
      // 退货申请
      {
        path: 'return/index',
        name: 'return-index',
        meta: {
          title: '退货申请列表',
          auth: true,
          cache: true
        },
        component: _import('shop/return/index')
      },
      // 商户退货
      {
        path: 'return/supplierReturn',
        name: 'return-supplierReturn',
        meta: {
          title: '商户退货详情',
          auth: true,
          cache: true
        },
        component: _import('shop/return/supplierReturn')
      },
      // 商户退货列表
      {
        path: 'return/supplierReturnList',
        name: 'return-supplierReturnList',
        meta: {
          title: '商户退货列表',
          auth: true,
          cache: true
        },
        component: _import('shop/return/supplierReturnList')
      },
      // 上门取件订单
      {
        path: 'return/pickupOrders',
        name: 'return-pickupOrders',
        meta: {
          title: '上门取件订单',
          auth: true,
          cache: true
        },
        component: _import('shop/return/pickupOrders')
      },

      // 充值列表
      {
        path: 'statistics/rechargeList',
        name: 'statistics-rechargeList',
        meta: {
          title: '资金流水明细',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/rechargeList')
      },
      {
        path: 'statistics/giftStatistics',
        name: 'statistics-giftStatistics',
        meta: {
          title: '礼品统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/giftStatistics')
      },
      {
        path: 'statistics/outOfStockLog',
        name: 'statistics-outOfStockLog',
        meta: {
          title: '缺货记录明细',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/outOfStockLog')
      },
      {
        path: 'statistics/evaluateStatistic',
        name: 'statistics-evaluateStatistic',
        meta: {
          title: '评价统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/evaluateStatistic')
      },
      {
        path: 'statistics/inventoryChecking',
        name: 'statistics-inventoryChecking',
        meta: {
          title: '库存统计',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/inventoryChecking')
      },
      {
        path: 'statistics/salesReport',
        name: 'statistics-salesReport',
        meta: {
          title: '商品销量报表',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/salesReport')
      },
      {
        path: 'statistics/storeCapitalDetails',
        name: 'statistics-storeCapitalDetails',
        meta: {
          title: '收款代划转明细',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/storeCapitalDetails')
      },
      {
        path: 'statistics/supplierCapitalDetails',
        name: 'statistics-supplierCapitalDetails',
        meta: {
          title: '商户收款代划转明细',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/supplierCapitalDetails')
      },
      // 小程序首页轮播图设置
      {
        path: 'system/setSwiperImg',
        name: 'miniAppSet-setSwiperImg',
        meta: {
          title: '小程序/app',
          auth: true,
          cache: true
        },
        component: _import('shop/miniAppSet/setSwiperImg')
      },
      // 小程序首页设置
      // {
      //   path: 'viewPage/editorIndex',
      //   name: 'viewPage-editorIndex',
      //   meta: {
      //     title: '小程序首页设置',
      //     auth: true,
      //     cache: true
      //   },
      //   component: _import('module/editorModule/viewPage/editorIndex')
      // },
      // 模块设置
      {
        path: 'system/moduleSet',
        name: 'system-moduleSet',
        meta: {
          title: '模块设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/moduleSet')
      },
      // 站点设置
      {
        path: 'system/basicSet',
        name: 'system-basicSet',
        meta: {
          title: '站点设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/basicSet')
      },
      // 标签库
      {
        path: 'system/tagLibrary',
        name: 'system-tagLibrary',
        meta: {
          title: '标签库',
          auth: true,
          cache: true
        },
        component: _import('shop/system/tagLibrary')
      },
      //页面装修
      {
        path: 'system/appletsetup',
        name: 'system-appletsetup',
        meta: {
          title: '页面装修',
          auth: true,
          cache: true
        },
        component: _import('shop/system/appletsetup')
      },
      // 基本设置
      {
        path: 'system/baseSet',
        name: 'system-baseSet',
        meta: {
          title: '基本设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/baseSet')
      },
      // 上传设置
      {
        path: 'system/uploadSet',
        name: 'system-uploadSet',
        meta: {
          title: '上传设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/uploadSet')
      },
      // SEO设置
      {
        path: 'system/seoSet',
        name: 'system-seoSet',
        meta: {
          title: 'SEO设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/seoSet')
      },
      {
        path: 'system/compony',
        name: 'system-compony',
        meta: {
          title: '物流公司',
          auth: true,
          cache: true
        },
        component: _import('shop/system/compony')
      },
      {
        path: 'system/transport',
        name: 'system-transport',
        meta: {
          title: '运费模版',
          auth: true,
          cache: true
        },
        component: _import('shop/system/transport')
      },
      {
        path: 'system/contract',
        name: 'system-contract',
        meta: {
          title: '合同设置',
          auth: true,
          cache: true
        },
        component: _import('shop/system/contract')
      },
      {
        path: 'system/editContract',
        name: 'goods-editContract',
        meta: {
          title: '编辑合同',
          auth: true,
          cache: true
        },
        component: _import('shop/system/editContract')
      },
      {
        path: 'system/orderStatisticsDescription',
        name: 'system-orderStatisticsDescription',
        meta: {
          title: '订单统计说明',
          auth: true,
          cache: true
        },
        component: _import('shop/system/orderStatisticsDescription')
      },
       // 新品折扣
      {
        path: 'promoteSale/newProductDiscount',
        name: 'promoteSale-newProductDiscount',
        meta: {
          title: '新品折扣',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/newProductDiscount')
      },
      // 优惠券列表
      {
        path: 'promoteSale/couponList',
        name: 'coupon-couponList',
        meta: {
          title: '优惠券列表',
          auth: true,
          cache: true
        },
        component: _import('shop/coupon/couponList')
      },
      // 优惠券log
      {
        path: 'promoteSale/couponLog',
        name: 'coupon-couponLog',
        meta: {
          title: '优惠券log',
          auth: true,
          cache: true
        },
        component: _import('shop/coupon/couponLog')
      },
      // 礼品活动列表
      {
        path: 'promoteSale/giftEvent',
        name: 'promoteSale-giftEvent',
        meta: {
          title: '购物车满送',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/giftEvent')
      },
      // 累计活动
      {
        path: 'promoteSale/cumulativeEvent',
        name: 'promoteSale-cumulativeEvent',
        meta: {
          title: '累计活动列表',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/cumulativeEvent')
      },
      // 直播抽奖
      {
        path: 'livebroadcast/luckyDraw',
        name: 'livebroadcast-luckyDraw',
        meta: {
          title: '直播抽奖',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/luckyDraw')
      },
      // 赠品发放 （购物车商品免费添加记录列表）
      {
        path: 'promoteSale/cartGiftLog',
        name: 'promoteSale-cartGiftLog',
        meta: {
          title: '赠品发放',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/cartGiftLog')
      },
      {
        path: 'promoteSale/giftBag',
        name: 'promoteSale-giftBag',
        meta: {
          title: '礼包管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/giftBag')
      },
      // 每日特惠
      {
        path: 'promoteSale/dailyDealList',
        name: 'promoteSale-dailyDealList',
        meta: {
          title: '每日特惠列表',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/dailyDealList')
      },
      // 局部满减满送活动列表
      {
        path: 'promoteSale/fullDelivery',
        name: 'promoteSale-fullDelivery',
        meta: {
          title: '百万补贴',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/fullDelivery')
      },
      // 百万补贴(电销)
      {
        path: 'telSalesManagement/fullDeliveryDianXiao',
        name: 'telSalesManagement-fullDeliveryDianXiao',
        meta: {
          title: '电销活动广场',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/fullDeliveryDianXiao')
      },
       // 专享活动
       {
        path: 'telSalesManagement/exclusiveEvent',
        name: 'telSalesManagement-exclusiveEvent',
        meta: {
          title: '私人定制',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/exclusiveEvent')
      },
      // 私人定制商品池
      {
        path: 'telSalesManagement/exclusiveEventCommodityPool',
        name: 'telSalesManagement-exclusiveEventCommodityPool',
        meta: {
          title: '私人定制商品池',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/exclusiveEventCommodityPool')
      },
       // 专享优惠商品池
       {
        path: 'telSalesManagement/exclusiveDiscountProductPool',
        name: 'telSalesManagement-exclusiveDiscountProductPool',
        meta: {
          title: '专享优惠商品池',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/exclusiveDiscountProductPool')
      },
      // 礼品池
      {
        path: 'telSalesManagement/giftGoodsPool',
        name: 'telSalesManagement-giftGoodsPool',
        meta: {
          title: '礼品池',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/giftGoodsPool')
      },
      // 互斥标签
      {
        path: 'telSalesManagement/mutualExclusionLabel',
        name: 'telSalesManagement-mutualExclusionLabel',
        meta: {
          title: '互斥标签',
          auth: true,
          cache: true
        },
        component: _import('shop/telSalesManagement/mutualExclusionLabel')
      },
      // 局部满减满送礼包管理
      {
        path: 'promoteSale/deliveryGift',
        name: 'promoteSale-deliveryGift',
        meta: {
          title: '局部满减满送礼包管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/deliveryGift')
      },
      {
        path: 'promoteSale/giftManage',
        name: 'promoteSale-giftManage',
        meta: {
          title: '礼品管理',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/giftManage')
      },
      {
        path: 'promoteSale/fullDiscount',
        name: 'promoteSale-fullDiscount',
        meta: {
          title: '区域折扣',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/fullDiscount')
      },
      {
        path: 'promoteSale/regionaDiscount',
        name: 'promoteSale-regionaDiscount',
        meta: {
          title: '区域折扣（新）',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/regionaDiscount')
      },
      {
        path: 'promoteSale/groupbooking',
        name: 'promoteSale-groupbooking',
        meta: {
          title: '拼团活动',
          auth: true,
          cache: true
        },
        component: _import('shop/promoteSale/groupbooking')
      },
      {
        path: 'searchRecoed/searchUserList',
        name: 'searchRecoed-searchUserList',
        meta: {
          title: '搜索统计',
          auth: true,
          cache: true
        },
        component: _import('shop/searchRecoed/searchUserList')
      },
      {
        path: 'searchRecoed/searchHistory',
        name: 'searchRecoed-searchHistory',
        meta: {
          title: '搜索历史',
          auth: true,
          cache: true
        },
        component: _import('shop/searchRecoed/searchHistory')
      },
      {
        path: 'searchRecoed/searchKeyword',
        name: 'searchRecoed-searchKeyword',
        meta: {
          title: '关键词列表',
          auth: true,
          cache: true
        },
        component: _import('shop/searchRecoed/searchKeyword')
      },
      {
        path: 'searchRecoed/correctWrongWords',
        name: 'searchRecoed-correctWrongWords',
        meta: {
          title: '错词纠正列表',
          auth: true,
          cache: true
        },
        component: _import('shop/searchRecoed/correctWrongWords')
      },
      {
        path: 'partner/signInRecord',
        name: 'partner-signInRecord',
        meta: {
          title: '打卡记录',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/signInRecord')
      },
      {
        path: 'partner/signInTrack',
        name: 'partner-signInTrack',
        meta: {
          title: '打卡轨迹',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/signInTrack')
      },
      {
        path: 'partner/signIn',
        name: 'partner-signIn',
        meta: {
          title: '合伙人打卡统计',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/signIn')
      },
      {
        path: 'partner/rechargeLog',
        name: 'partner-rechargeLog',
        meta: {
          title: '合伙人充值',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/rechargeLog')
      },
      {
        path: 'partner/commission',
        name: 'partner-commission',
        meta: {
          title: '合伙人佣金',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/commission')
      },
      {
        path: 'partner/setTheRoute',
        name: 'partner-setTheRoute',
        meta: {
          title: '后台路线列表',
          auth: true,
          cache: true
        },
        component: _import('shop/partner/setTheRoute')
      },
      // 系统 前端日志
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: true
        },
        component: _import('system/log')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      },
      // 快递赔付单
      {
        path: 'afterSaleManagement/expressPaymentSlip',
        name: 'afterSaleManagement-expressPaymentSlip',
        meta: {
          title: '快递赔付单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/expressPaymentSlip')
      },
      // 售后工单
      {
        path: 'afterSaleManagement/afterSaleOrder',
        name: 'afterSaleManagement-afterSaleOrder',
        meta: {
          title: '售后工单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/afterSaleOrder')
      },
      // 售后工单审核
      {
        path: 'afterSaleManagement/afterSaleOrderCheck',
        name: 'afterSaleManagement-afterSaleOrderCheck',
        meta: {
          title: '售后工单审核',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/afterSaleOrderCheck')
      },
      // 收/退款单
      {
        path: 'afterSaleManagement/receiptRefundForm',
        name: 'afterSaleManagement-receiptRefundForm',
        meta: {
          title: '收/退款单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/receiptRefundForm')
      },
      // 退货单
      {
        path: 'afterSaleManagement/returnGoodsForm',
        name: 'afterSaleManagement-returnGoodsForm',
        meta: {
          title: '退货单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/returnGoodsForm')
      },
      // 补货单
      {
        path: 'afterSaleManagement/replenishmentForm',
        name: 'afterSaleManagement-replenishmentForm',
        meta: {
          title: '补货单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/replenishmentForm')
      },
      // 充值单
      {
        path: 'afterSaleManagement/rechargeForm',
        name: 'afterSaleManagement-rechargeForm',
        meta: {
          title: '充值单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/rechargeForm')
      },
      // 退货申请
      {
        path: 'afterSaleManagement/index',
        name: 'afterSaleManagement-index',
        meta: {
          title: '退货申请列表',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/index')
      },
      // 上门取件订单
      {
        path: 'afterSaleManagement/pickupOrders',
        name: 'afterSaleManagement-pickupOrders',
        meta: {
          title: '上门取件订单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/pickupOrders')
      },
      // 上门取件订单京东
      {
        path: 'afterSaleManagement/pickupOrdersJD',
        name: 'afterSaleManagement-pickupOrdersJD',
        meta: {
          title: '京东上门取件订单',
          auth: true,
          cache: true
        },
        component: _import('shop/afterSaleManagement/pickupOrdersJD')
      },
      // 统计中心-商品成本
      {
        path: 'statistics/commodityCost',
        name: 'statistics-commodityCost',
        meta: {
          title: '商品成本',
          auth: true,
          cache: true
        },
        component: _import('shop/statistics/commodityCost')
      },

      // 电商收付通-商户列表
      {
        path: 'EcommercePaymentPass/merchantList',
        name: 'EcommercePaymentPass-merchantList',
        meta: {
          title: '商户列表',
          auth: true,
          cache: true
        },
        component: _import('shop/EcommercePaymentPass/merchantList')
      },
      // 电商收付通-收付通四方分账
      {
        path: 'EcommercePaymentPass/shoufutongFourPartySplitPayment',
        name: 'EcommercePaymentPass-shoufutongFourPartySplitPayment',
        meta: {
          title: '收付通四方分账',
          auth: true,
          cache: true
        },
        component: _import('shop/EcommercePaymentPass/shoufutongFourPartySplitPayment')
      },
       // 电商收付通-提现管理
       {
        path: 'EcommercePaymentPass/withdrawalManagement',
        name: 'EcommercePaymentPass-withdrawalManagement',
        meta: {
          title: '提现管理',
          auth: true,
          cache: true
        },
        component: _import('shop/EcommercePaymentPass/withdrawalManagement')
      },
      {
        path: 'alipaySaleManagement/modifylog',
        name: 'alipaySaleManagement-modifylog',
        meta: {
          title: '修改日志',
          auth: true,
          cache: true
        },
        component: _import('shop/alipaySaleManagement/modifylog')
      },
      // 支付宝直付通-商户列表
      {
        path: 'alipaySaleManagement/merchantList',
        name: 'alipaySaleManagement-merchantList',
        meta: {
          title: '商户列表',
          auth: true,
          cache: true
        },
        component: _import('shop/alipaySaleManagement/merchantList')
      },
      // 支付宝直付通——二级商户入驻进度列表
      {
        path: 'alipaySaleManagement/merchant_settlement_inquiry',
        name: 'alipaySaleManagement-merchant_settlement_inquiry',
        meta: {
          title: '二级商户入驻进度列表',
          auth: true,
          cache: true
        },
        component: _import('shop/alipaySaleManagement/merchant_settlement_inquiry')
      },
      // 电商收付通-提现记录
      {
        path: 'EcommercePaymentPass/withdrawalRecord',
        name: 'EcommercePaymentPass-withdrawalRecord',
        meta: {
          title: '提现记录',
          auth: true,
          cache: true
        },
        component: _import('shop/EcommercePaymentPass/withdrawalRecord')
      },
      // 直播管理
      {
        path: 'livebroadcast/liveRoom',
        name: 'livebroadcast-liveRoom',
        meta: {
          title: '直播管理',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/liveRoom')
      },
      {
        path: 'livebroadcast/livestreamer',
        name: 'livebroadcast-livestreamer',
        meta: {
          title: '直播人员',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/livestreamer')
      },
      {
        path: 'livebroadcast/liveevent',
        name: 'livebroadcast-liveevent',
        meta: {
          title: '直播活动',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/liveevent')
      },
      {
        path: 'livebroadcast/chatlist',
        name: 'livebroadcast-chatlist',
        meta: {
          title: '聊天列表',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/chatlist')
      },
      {
        path: 'livebroadcast/awardlist',
        name: 'livebroadcast-awardlist',
        meta: {
          title: '中奖列表',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/awardlist')
      },
      {
        path: 'livebroadcast/fullDeliveryLive',
        name: 'livebroadcast-fullDeliveryLive',
        meta: {
          title: '直播特惠',
          auth: true,
          cache: true
        },
        component: _import('shop/livebroadcast/fullDeliveryLive')
      },
      // OA公告管理
      {
        path: 'OAManagement/noticeManagement',
        name: 'OAManagement-noticeManagement',
        meta: {
          title: '公告管理',
          auth: true,
          cache: true
        },
        component: _import('shop/OAManagement/noticeManagement')
      },
      // 超时发货规则设置
      {
        path: 'OAManagement/setTimeoutDeliveryRule',
        name: 'OAManagement-setTimeoutDeliveryRule',
        meta: {
          title: '超时发货规则设置',
          auth: true,
          cache: true
        },
        component: _import('shop/OAManagement/setTimeoutDeliveryRule')
      },
      // 视频上传
      {
        path: 'OAManagement/warehouseVideo',
        name: 'OAManagement-warehouseVideo',
        meta: {
          title: '视频上传',
          auth: true,
          cache: true
        },
        component: _import('shop/OAManagement/warehouseVideo')
      },
      // 第三方平台-销售单
      {
        path: 'thirdPartyPlatform/salesTicket',
        name: 'thirdPartyPlatform-salesTicket',
        meta: {
          title: '销售单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/salesTicket')
      },
      // 第三方平台-销售单商品统计
      {
        path: 'thirdPartyPlatform/salesTicketGoodsStatistics',
        name: 'thirdPartyPlatform-salesTicketGoodsStatistics',
        meta: {
          title: '销售单商品统计',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/salesTicketGoodsStatistics')
      },
      // 第三方平台-第三方验收单
      {
        path: 'thirdPartyPlatform/warehouseReceiptList',
        name: 'thirdPartyPlatform-warehouseReceiptList',
        meta: {
          title: '第三方验收单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/warehouseReceiptList')
      },
       // 第三方平台-第三方对账单
      {
        path: 'thirdPartyPlatform/thirdStatement',
        name: 'thirdPartyPlatform-thirdStatement',
        meta: {
          title: '第三方对账单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdStatement')
      },
       // 第三方平台-抖音配货记录
      {
        path: 'thirdPartyPlatform/douyinDeliveryRecord',
        name: 'thirdPartyPlatform-douyinDeliveryRecord',
        meta: {
          title: '抖音配货记录',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/douyinDeliveryRecord')
      },
      // 第三方平台-第三方提现单
      {
        path: 'thirdPartyPlatform/thirdPlatformWithdrawalRequest',
        name: 'thirdPartyPlatform-thirdPlatformWithdrawalRequest',
        meta: {
          title: '第三方提现单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdPlatformWithdrawalRequest')
      },
      // 第三方平台-第三方期初建账
      {
        path: 'thirdPartyPlatform/thirdBeginningSetUpAccountingRecords',
        name: 'thirdPartyPlatform-thirdBeginningSetUpAccountingRecords',
        meta: {
          title: '第三方期初建账列表',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdBeginningSetUpAccountingRecords')
      },
      // 第三方平台-第三方其他付款单
      {
        path: 'thirdPartyPlatform/thirdOtherPaymentSlips',
        name: 'thirdPartyPlatform-thirdOtherPaymentSlips',
        meta: {
          title: '第三方其他付款单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdOtherPaymentSlips')
      },
      // 第三方平台-第三方其他收款单
      {
        path: 'thirdPartyPlatform/thirdOtherReceipts',
        name: 'thirdPartyPlatform-thirdOtherReceipts',
        meta: {
          title: '第三方其他收款单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdOtherReceipts')
      },
      // 第三方平台-第三方日记账汇总表
      {
        path: 'thirdPartyPlatform/thirdJournalLedgerSummaryTable',
        name: 'thirdPartyPlatform-thirdJournalLedgerSummaryTable',
        meta: {
          title: '第三方日记账汇总表',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdJournalLedgerSummaryTable')
      },
      // 第三方平台-第三方预付款单
      {
        path: 'thirdPartyPlatform/thirdAdvanceSingleNew',
        name: 'thirdPartyPlatform-thirdAdvanceSingleNew',
        meta: {
          title: '第三方预付款单',
          auth: true,
          cache: true
        },
        component: _import('shop/thirdPartyPlatform/thirdAdvanceSingleNew')
      },


      //拆装单
      {
        path: 'storehouse/disassemblyList',
        name: 'storehouse-disassemblyList',
        meta: {
          title: '拆装单',
          cache: true,
          auth: true
        },
        component: _import('purchase/order/disassemblyList')
      },
      //区域价标签
      {
        path: 'goods/areaPriceTag',
        name: 'goods-areaPriceTag',
        meta: {
          title: '区域价标签',
          cache: true,
          auth: true
        },
        component: _import('shop/goods/areaPriceTag')
      },
      //产品信息
      {
        path: 'marketResearch/productInfo',
        name: 'marketResearch-productInfo',
        meta: {
          title: '产品信息',
          cache: true,
          auth: true
        },
        component: _import('shop/marketResearch/productInfo')
      },
      //热销产品
      {
        path: 'marketResearch/hotSellingProduct',
        name: 'marketResearch-hotSellingProduct',
        meta: {
          title: '热销产品',
          cache: true,
          auth: true
        },
        component: _import('shop/marketResearch/hotSellingProduct')
      },
      //市场车型
      {
        path: 'marketResearch/marketModel',
        name: 'marketResearch-marketModel',
        meta: {
          title: '市场车型',
          cache: true,
          auth: true
        },
        component: _import('shop/marketResearch/marketModel')
      },
      //客户需求
      {
        path: 'marketResearch/customerDemand',
        name: 'marketResearch-customerDemand',
        meta: {
          title: '客户需求',
          cache: true,
          auth: true
        },
        component: _import('shop/marketResearch/customerDemand')
      },
      // 问卷调查
      {
        path: 'marketResearch/questionSurvey',
        name: 'marketResearch-questionSurvey',
        meta: {
          title: '问卷调查',
          cache: true,
          auth: true
        },
        component: _import('shop/marketResearch/questionSurvey')
      },
      //报销单
      {
        path: 'financialManagement/otherPaymentOrder',
        name: 'financialManagement-otherPaymentOrder',
        meta: {
          title: '报销单',
          cache: true,
          auth: true
        },
        component: _import('shop/financialManagement/otherPaymentOrder')
      },
      //库存盘点记录
      {
        path: 'storehouse/stockCountRecord',
        name: 'storehouse-stockCountRecord',
        meta: {
          title: '库存盘点记录',
          auth: true,
          cache: true
        },
        component: _import('shop/goods/stockCountRecord')
      },
      // 运营商列表
       {
        path: 'operatorManagement/operatorList',
        name: 'operatorManagement-operatorList',
        meta: {
          title: '运营商列表',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/operatorList')
      },
      // 运营商账单报表
      {
      path: 'operatorManagement/operatorBillReport',
      name: 'operatorManagement-operatorBillReport',
      meta: {
          title: '运营商账单报表',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/operatorBillReport')
     },
     // 运营商每日账单汇总
     {
      path: 'operatorManagement/dailyOperatorBillReport',
      name: 'operatorManagement-dailyOperatorBillReport',
      meta: {
          title: '运营商每日账单汇总',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/dailyOperatorBillReport')
     },
     // 我的运营商信息
     {
      path: 'operatorManagement/myCarriersInfo',
      name: 'operatorManagement-myCarriersInfo',
      meta: {
          title: '我的运营商信息',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/myCarriersInfo')
     },
     // 运营商修改申请列表
     {
      path: 'operatorManagement/carriersInfoReviseApplicationList',
      name: 'operatorManagement-carriersInfoReviseApplicationList',
      meta: {
          title: '运营商修改申请列表',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/carriersInfoReviseApplicationList')
     },
     // 运营商提现单
     {
      path: 'operatorManagement/carriersWithdrawalOrder',
      name: 'operatorManagement-carriersWithdrawalOrder',
      meta: {
          title: '运营商提现单',
          auth: true,
          cache: true
        },
        component: _import('shop/operatorManagement/carriersWithdrawalOrder')
     },
     // 平台基本信息
     {
        path: 'platform/taxInfoExport',
        name: 'platform-taxInfoExport',
        meta: {
          title: '涉税信息导出',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/TaxInfoExport')
      },
      {
      path: 'platform/platformInfo',
      name: 'platform-platformInfo',
      meta: {
          title: '基本信息',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/platformInfo')
     },
     // 平台账单列表
      {
        path: 'platform/platformBillReport',
        name: 'platform-platformBillReport',
        meta: {
          title: '平台账单列表',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/platformBillReport')
      },
      // 平台每日账单汇总
      {
        path: 'platform/dailyPlatformBillSummary',
        name: 'platform-dailyPlatformBillSummary',
        meta: {
          title: '平台每日账单汇总',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/dailyPlatformBillSummary')
      },
       // 平台提现单
       {
        path: 'platform/platformWithdrawalOrder',
        name: 'platform-platformWithdrawalOrder',
        meta: {
          title: '平台提现单',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/platformWithdrawalOrder')
      },
      // 开票信息
      {
        path: 'platform/invoiceInformation',
        name: 'platform-invoiceInformation',
        meta: {
          title: '开票信息',
          auth: true,
          cache: true
        },
        component: _import('shop/platform/invoiceInformation')
      },
      // 商户账单报表
      {
        path: 'factory/supplierInvoicesList',
        name: 'factory-supplierInvoicesList',
        meta: {
          title: '商户账单报表',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/supplierInvoicesList')
      },
      // 数据申报预警
      {
        path: 'factory/dataSubmissionWarning',
        name: 'factory-dataSubmissionWarning',
        meta: {
          title: '数据申报预警',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/dataSubmissionWarning')
      },
      // 我的商户信息
      {
        path: 'factory/myShoptInfo',
        name: 'factory-myShoptInfo',
        meta: {
          title: '我的商户信息',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/myShoptInfo')
      },
      // 商户修改申请列表
      {
        path: 'factory/shoptInfoReviseApplicationList',
        name: 'factory-shoptInfoReviseApplicationList',
        meta: {
          title: '商户修改申请列表',
          auth: true,
          cache: true
        },
        component: _import('shop/shopt/shoptInfoReviseApplicationList')
      },
      // 视频管理
      {
        path: 'video/videoManagement',
        name: 'shop-video-videoManagement',
        meta: {
          title: '视频添加',
          auth: true,
          cache: true
        },
        component: _import('shop/video/videoManagement')
      },
      // 作品列表
      {
        path: 'video/works',
        name: 'shop-video-works',
        meta: {
          title: '作品列表',
          auth: true,
          cache: true
        },
        component: _import('shop/video/works')
      },
      // 作品评论列表
      {
        path: 'video/comments',
        name: 'shop-video-comments',
        meta: {
          title: '评论列表',
          auth: true,
          cache: true
        },
        component: _import('shop/video/comments')
      },
      // 视频活动列表
      {
        path: 'video/videoActivitiesList',
        name: 'video-videoActivitiesList',
        meta: {
          title: '视频活动列表',
          auth: true,
          cache: true
        },
        component: _import('shop/video/videoActivitiesList')
      },
      // 二级账户列表
      {
        path: 'secondaryAccounts/secondaryAccountsList',
        name: 'secondaryAccounts-secondaryAccountsList',
        meta: {
          title: '二级账户列表',
          auth: true,
          cache: true
        },
        component: _import('shop/secondaryAccounts/secondaryAccountsList')
      },


    ]
  }
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login/page')
  },
  {
    path: '/login1',
    name: 'login1',
    component: _import('system/login/page1')
  }
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]
